import React from "react";
import GithubIcon from "mdi-material-ui/GithubCircle";

export default function Github(props) {
  return <GithubIcon {...props} />;
}
